<template>
  <div class="web-content">
    <swiper :type="3"></swiper>
    <newsmove v-show="!showDetail" v-model="showDetail"></newsmove>
    <newsdetail v-if="showDetail" v-model="showDetail"></newsdetail>
  </div>
</template>
<script>
import swiper from "./swiper";
import newsmove from "./news/newsmove";
import newsdetail from "./news/newsdetail";

export default {
  data() {
    return {
      showDetail: false
    };
  },
  components: {
    swiper,
    newsmove,
    newsdetail
  }
};
</script>

